module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "img-responsive col-md-4 col-sm-12 col-xs-12 img-rounded",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-8"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-primary btn-share",
    on: {
      "click": function($event) {
        _vm.saveComponent(_vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" Save CNpro\r\n                                    \r\n                                ")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.cnpro.cnpro_description) + ".")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.user_premuim_plan_id != 1) ? _c('div', [_c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_vm._v("Social Handles: ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_twitter
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_facebook
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_instagram
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])]), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.user_premuim_plan_id != 1) ? _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-contact row"
  }, [_c('div', {
    staticClass: "detail-contact-address col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_address))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-email col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_email))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-contact row"
  }, [_c('div', {
    staticClass: "detail-contact-phone col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_phone))])]), _vm._v(" "), _vm._m(0)])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row detail-content"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [(_vm.cnpro.cnpro_rating_average_rate) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.cnpro.cnpro_rating_average_rate) + " ")]), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "goldenrod"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("(" + _vm._s(_vm.cnpro.cnpro_rating_total_rating) + ") ")]), _vm._v(", \r\n                                    ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_reviews_total_count) + " reviews")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v("All Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [(_vm.cnpro.cnpro_reviews.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No reviews yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cnpro.cnpro_reviews), function(review) {
    return [_c('div', {
      staticClass: "review"
    }, [_c('div', {
      staticClass: "review-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.img_url + review.review_user_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review-inner"
    }, [_c('div', {
      staticClass: "review-title"
    }, [_c('h2', [_vm._v(_vm._s(review.review_user))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "review-overall-rating"
    }, [_c('span', {
      staticClass: "overall-rating-title"
    }, [_vm._v("Total Score:")]), _vm._v(" "), _vm._l((review.review_user_rate), function(rate) {
      return [_c('i', {
        staticClass: "fa fa-star"
      })]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "review-content-wrapper"
    }, [_c('div', {
      staticClass: "review-content"
    }, [_c('div', {
      staticClass: "review-pros"
    }, [_c('p', [_vm._v(_vm._s(review.review_review) + ".")])])])])])])]
  })], 2)]), _vm._v(" "), (_vm.user.user_premuim_plan_id == 1) ? _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block col-sm-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveToPlans
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("Chat with CNpro")])]) : _c('div', {
    staticClass: "col-sm-5"
  }, [_c('h2', [_vm._v("How May I Help You?")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [(_vm.activeRequest) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active discussion with this CNpro")]), _vm._v(" "), _vm._m(2)]) : _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.details),
      expression: "request.details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "placeholder": "Start Typing...",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.request.details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.requestQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("Send")])])])])])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-contact-website col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "report"
  }, [_c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "title": "Report",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "contracts",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("View Discussion")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Let's Chat "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac1d00e4"}!./src/components/Cnpro/template.html
// module id = 313
// module chunks = 0